import styled from "styled-components";

export const Container = styled.div`
    padding: 25px 40px;
    height: 150px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(0,0,0,0.1);
    background-color: var(--black);

    @media (max-width: 768px) {
      padding: 15px 20px;
      gap: 10px;
    }

`

export const Logo = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    width: 200px;
    z-index: 2;
    @media (max-width: 768px) {
      width: 100px;
    }
  }

  p {
    position: absolute;
    bottom: 28px;
    color: var(--gold);
    font-size: 0.8rem;
    z-index: 1;
    @media (max-width: 768px) {
      font-size: 0.5rem;
      bottom: 12px;
    }
  }
`

export const Menu = styled.div`
  ul {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    list-style: none;
    padding: 0;
  }

  li {
    border: 1px solid var(--gold);
    border-radius: 10px;
    padding: 10px;
    color: var(--gold);
    transition: all 0.3s ease;

    @media (max-width: 768px) {
      padding: 6px 10px;
    }

    a {
      text-decoration: none;
      color: var(--gold);
      display: flex;
      align-items: center;

      span {
        font-size: 1.2rem;
        font-weight: 300;

        @media (max-width: 768px) {
          font-size: 1rem;
        }
      }
    }

    &:hover {
      background-color: var(--gold);
      cursor: pointer;

      a {
        color: var(--primary);
      }
    }
  }
`